import {Layout} from 'antd';
const {Footer } = Layout;

//分共底部组件
const FooterComponent = () => {
  return (
    <Footer>
      <div className='footer'>
        <a className='footer' href="https://www.cangweizaixian.com">仓位在线首页</a> |
        <a className='footer'  href="https://duanxianwang.duishu.com/"> 短线王</a> | 
        <a className='footer' href="https://www.duishu.com/"> 对数智投</a> 
      </div>
        <div className='footer'>数据基于历史，不代表未来趋势；仅供投资者参考，不构成投资建议 </div>
        <div className='footer'>邮箱：app@duishu.com | 版权归属：© 2025 对数智投（北京）科技有限公司 <a className='footer'  style={{ textDecoration:'underline' }}  href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备18020913号-6</a></div>
    </Footer>
  )
}

export default FooterComponent;